/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { Row, Col, Table, Button } from "react-bootstrap";
import { getRunsheet, getExternalEntities } from "../../actions/runsheets";
import JobList from "../jobs/JobList";
import CompletedJobList from "../jobs/CompletedJobList";
import JobsViewMapComponent from "../../MapView";
import Loading from "../Loading";
import StatusHelper from "../StatusHelper";

const RunsheetDates = ({ runsheet }) => {
  const dateFormat = "D MMM YYYY";
  const createdAt = moment(runsheet.createdAt).format(dateFormat);
  const scheduledAt = moment(runsheet.scheduledAt).format(dateFormat);

  switch (runsheet.status) {
    case "COMPLETED":
      return (
        <ul className="list-unstyled">
          <li>Created on: {createdAt}</li>
        </ul>
      );
    default:
      return (
        <ul className="list-unstyled">
          <li>Created on: {createdAt}</li>
          <li>Scheduled for: {scheduledAt}</li>
        </ul>
      );
  }
};
RunsheetDates.propTypes = {
  runsheet: PropTypes.object.isRequired
};

const DeviceView = ({ device }) => {
  if (device.id) {
    return <span>{device.name}</span>;
  }

  return "";
};
DeviceView.propTypes = {
  device: PropTypes.object
};
DeviceView.defaultProps = {
  device: { id: "" }
};

class RunsheetView extends Component {
  state = {
    fetched: false,
    runsheet: {}
  };

  componentDidMount() {
    this.props
      .getRunsheet(this.props.match.params.id)
      .then(runsheet => this.setState({ runsheet }));
    this.props
      .getExternalEntities()
      .then(() => this.setState({ fetched: true }));
  }

  handleEditClick = () => {
    this.props.history.push(`${this.props.match.url}/edit`);
  };

  handleBackClick = () => {
    this.props.history.push("/runsheets");
  };

  render() {
    const { url } = this.props.match;
    if (this.state.fetched) {
      const { locations } = this.props;
      const { runsheet } = this.state;
      const { status } = runsheet;
      const jobs = runsheet.jobs || [];
      const dateFormat = "D MMM YYYY";
      // const createdAt = moment(runsheet.createdAt).format(dateFormat);
      const scheduledAt = moment(runsheet.scheduledAt).format(dateFormat);

      return (
        <div>
          <Row>
            <Col md={6}>
              <div className="r_view_label">
                <h4>
                  Runsheet: {runsheet.name}
                </h4>
              </div>
            </Col>
            <Col md={6}>
              <div className="pull-right r_view_label">
                {(status === "CREATED" || status === "OPENED") ? (
                  <Button bsStyle="primary" onClick={this.handleEditClick}>
                    EDIT
                  </Button>
                ) : (
                  ""
                )}{" "}
                <Button onClick={this.handleBackClick}>
                  VIEW ALL RUNSHEETS
                </Button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Table bordered>
                <thead>
                  <tr className="header">
                    <td>Name</td>
                    <td>Device</td>
                    <td>Vehicle</td>
                    <td>Driver</td>
                    <td>Status</td>
                    <td>Scheduled For</td>
                    <td>Details</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{runsheet.name}</td>
                    <td>
                      <DeviceView device={runsheet.device} />
                    </td>
                    <td>{runsheet.vehicle ? runsheet.vehicle.name : ""}</td>
                    <td>
                      {runsheet.user
                        ? `${runsheet.user.firstName} ${runsheet.user.lastName}`
                        : ""}
                    </td>
                    <td>{StatusHelper(status)}</td>
                    <td>{scheduledAt}</td>
                    <td>
                      <p>No. of Jobs: {jobs.length ? jobs.length : 0}</p>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>

          <Row>
            <Col md={7}>
              {runsheet.status === "COMPLETED" ? (
                <CompletedJobList
                  jobs={runsheet.jobs}
                  runsheet={runsheet}
                  path={url}
                />
              ) : (
                <JobList jobs={runsheet.jobs} runsheet={runsheet} path={url} />
              )}
            </Col>
            <Col md={5}>
              <div>
                <JobsViewMapComponent jobs={jobs} locations={locations} />
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    return <Loading />;
  }
}
RunsheetView.propTypes = {
  getRunsheet: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }),
    url: PropTypes.string
  }).isRequired,
  getExternalEntities: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  locations: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  const locations = state.locations.allIds.map(
    locationId => state.locations.byId[locationId]
  );

  return { locations };
}

export default connect(mapStateToProps, { getRunsheet, getExternalEntities })(
  RunsheetView
);



// WEBPACK FOOTER //
// ./src/components/runsheets/RunsheetView.js